import { createThrottle } from 'helpers/createThrottle';

import { addRumError } from './addRumError';

const rumThrottle = createThrottle();

const getErrorFingerprint = (error: unknown): string => {
  if (error instanceof Error) {
    const stackHead = error.stack?.split('\n')[1]?.trim() ?? '';
    return `${error.name}:${error.message}:${stackHead}`;
  }
  return String(error);
};

type AddRumErrorThrottledParams = {
  key: string;
  error: unknown;
  context?: Record<string, unknown>;
  throttleMs?: number;
};

/**
 * Prevents repeated high-frequency errors from flooding RUM.
 * Returns true when the error is sent, false when it is throttled.
 */
export const addRumErrorThrottled = ({ key, error, context, throttleMs }: AddRumErrorThrottledParams): boolean => {
  const fingerprintedKey = `${key}:${getErrorFingerprint(error)}`;
  const { throttled, suppressedCount } = rumThrottle.check(fingerprintedKey, throttleMs);

  if (throttled) return false;

  const sent = addRumError(error, {
    ...context,
    rumThrottledError: true,
    rumSuppressedCount: suppressedCount
  });

  if (sent) {
    rumThrottle.commitSuccess(fingerprintedKey, throttleMs);
  }

  return sent;
};
